import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthContext } from '../context/AuthContext'

/**
 * PermissionGate - wraps a route and redirects to /dashboard
 * with a toast if the user doesn't have the required permission.
 */
export function PermissionGate({ permission, children }) {
  const { hasPermission, loading } = useAuthContext()
  const navigate = useNavigate()

  const allowed = hasPermission(permission)

  useEffect(() => {
    if (!loading && !allowed) {
      // Dispatch a toast event before redirecting
      window.dispatchEvent(new CustomEvent('planos:permission-denied', {
        detail: { message: "You don't have access to this section" }
      }))
      navigate('/dashboard', { replace: true })
    }
  }, [loading, allowed, navigate])

  if (loading || !allowed) return null

  return children
}
